import { Component, Input} from '@angular/core';
@Component({
    selector: 'app-warning-message-find-result',
    templateUrl: './warning-message-find-result.component.html'
})
export class WarningMessageFindResultComponent {}